import React, { useEffect } from 'react';
import { CelebrationDrawerCta, CelebrationDrawerFrame } from '@components/ui/celebration-drawer';
import { DrawerDescription, DrawerTitle } from '@components/ui/drawer';
import { useAmplitudeTracking } from '@hooks/useAmplitudeTracking';
import { ANALYTICS_EVENTS } from '@lib/analytics-events';

/** Post-signup "You're all set" celebration (design §7) — full-profile completions only. */
export const SignupCelebrationDrawer: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const { trackEvent } = useAmplitudeTracking();
  useEffect(() => {
    trackEvent(ANALYTICS_EVENTS.signup_celebration_viewed, {});
  }, [trackEvent]);

  return (
    <CelebrationDrawerFrame
      onOpenChange={open => {
        if (!open) onClose();
      }}
    >
      <div className="flex flex-col items-center gap-2.5 pt-2 text-center">
        <span aria-hidden="true" className="text-6xl">
          🎉
        </span>
        {/* The kicker doubles as the drawer's accessible name. The frame renders no title of its
            own (celebration-drawer.tsx), so this is the sole title — without it the dialog is
            unnamed and Radix warns. Styled to keep the kicker's original look, overriding
            DrawerTitle's default text-lg/font-semibold. */}
        <DrawerTitle className="font-fira text-sm font-normal text-mb-dark-gray">
          You&apos;re all set
        </DrawerTitle>
        <DrawerDescription className="font-fira text-sm text-black">
          Take a look around, <span className="font-semibold">join communities</span>,{' '}
          <span className="font-semibold">attend events</span> and find the right people to
          collaborate on your next project.
        </DrawerDescription>
      </div>
      <CelebrationDrawerCta onClick={onClose}>Done</CelebrationDrawerCta>
    </CelebrationDrawerFrame>
  );
};
